import script from "./RunAddNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunAddNew.vue?vue&type=script&setup=true&lang=ts"

import "./RunAddNew.vue?vue&type=style&index=0&id=67c3c1fa&lang=scss"

const __exports__ = script;

export default __exports__